module.exports = __webpack_public_path__ + "img/hourglass-start.de41f69e.svg";